import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { merge, Observable, of } from 'rxjs';
import { map, switchMap, catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExpWinAccountabilityDetailService {

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router) { }

  getExpWinAccountabilityDetailsData(resId: number, auditLogId: number): Observable<any> {

    var url = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/SantaCruz/DataMonitorExpWinAccountabilityDetailsGet?resId=${resId}&auditLogId=${auditLogId}`;

    const intitial$: Observable<any> = of({
      workingText: 'Loading Data...',
      errorMessage: undefined
    });

    const loader$ = this.route.params.pipe(
      switchMap(d => 
        this.http.get(url)
        .pipe(
          map((d: any) => d),
          catchError(error => of({
            isLoading: false, 
            isLoaded: false,
            isError: true,
            workingText: '',
            isFound: 0,
            errorMessage: error.error instanceof ErrorEvent ? `an error occurred: ${error.error.message}` : `backend error: ${error.status} - ${error.message}`,
            data: {}
          }))
        )
      ),
      //tap(d => console.log(d)),
      map(d => ({
        items: d.items,
        lastUpdated: d.lastUpdated,
        isNotFound: d.items.length === 0,
        isLoading: false,
        isLoaded: true,
        isError: false,
        errorMessage: '',
        workingText: '',

        segmentRowId: d.segmentRowId,
        confirmationNumber: d.confirmationNumber,
        customer: d.customer,
        serviceAreaCode: d.serviceAreaCode,
        passenger: d.passenger,
        vehicleType: d.vehicleType,
        pickupAddress: d.pickupAddress,
        destinationAddress: d.destinationAddress,
        feedback: d.feedback,
        resAuditLogEntryId: d.items.length === 0 ? 0 : d.items[0].resAuditLogEntryId,
        needApproval: d.items.length === 0 ? 1 : d.items[0].needApproval
      })),
      catchError((e, v) => of({ workingText: undefined, errorMessage: e.message ? e.message : e }))
    );

    return merge(intitial$, loader$);
  }
}
